
define('template!productSelectDialogTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="dialog-blinder" class="dialog-blinder"></div>\n<div class="product-dialog-content">\n    <div class="select-product-region"></div>\n    <div class="user-action-buttons-block">\n        ';
 if (displayLeaveButton === true) { ;
__p += '\n        <a class="btn leave-button">\n            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>\n            <span>' +
((__t = ( _.i18n('common.quit') )) == null ? '' : __t) +
'</span>\n        </a>\n        ';
 } ;
__p += '\n        <a class="btn add-selected-products-button disabled">\n            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>\n            <span>' +
((__t = ( _.i18n('selectProduct.addSelected') )) == null ? '' : __t) +
'</span>\n        </a>\n    </div>\n</div>';

}
return __p
};});

